<template>
  <nav class="navbar">
    <div class="navbar-content">
      <div class="navbar-left">
        <img src="/logo-dnp.png" alt="DNP Logo" class="navbar-logo" />
        <router-link to="/registro" class="navbar-brand">
          Control de Asistencia
        </router-link>
      </div>
      
      <ul class="navbar-menu">
        <li><router-link to="/registro">Registrar</router-link></li>
        <li v-if="isAdmin"><router-link to="/admin">Administración</router-link></li>
        <li v-if="isAdmin"><router-link to="/cargos-equipos">Cargos y Equipos</router-link></li>
        <li v-if="isAdmin"><router-link to="/reportes">Reportes</router-link></li>
        <li v-if="isAdmin"><router-link to="/configuracion">Configuración</router-link></li>
        <li v-else><router-link to="/usuario">Mi Panel</router-link></li>
        <li>
          <span style="color: #6e6e73; margin-right: 12px;">{{ user?.nombre }}</span>
          <button @click="handleLogout" class="btn btn-secondary" style="padding: 8px 16px; font-size: 13px;">
            Cerrar Sesión
          </button>
        </li>
      </ul>
    </div>
    
    <!-- Aviso de Mora o Suspensión -->
    <div v-if="mostrarAvisoMora" :class="['aviso-mora', sistemaSuspendido ? 'sistema-suspendido' : '']">
      <div class="aviso-mora-content">
        <span class="aviso-mora-icon">{{ sistemaSuspendido ? '🚫' : '⚠️' }}</span>
        <span class="aviso-mora-texto">{{ mensajeMora }}</span>
        <span class="aviso-mora-icon">{{ sistemaSuspendido ? '🚫' : '⚠️' }}</span>
      </div>
    </div>
    
    <!-- Overlay bloqueador cuando está suspendido -->
    <div v-if="sistemaSuspendido" class="overlay-suspendido" @click.prevent.stop>
      <div class="mensaje-suspendido">
        <h1>🚫 Sistema Suspendido</h1>
        <p>El servicio se encuentra temporalmente suspendido.</p>
        <p>Por favor contacte con el administrador.</p>
      </div>
    </div>
  </nav>
</template>

<script>
import { computed, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import api from '../services/api';

export default {
  name: 'Navbar',
  setup() {
    const authStore = useAuthStore();
    const router = useRouter();

    const user = computed(() => authStore.user);
    const isAdmin = computed(() => authStore.isAdmin);

    const mostrarAvisoMora = ref(false);
    const mensajeMora = ref('');
    const modoSistema = ref(1); // 1 = normal/mora, 2 = suspendido
    const sistemaSuspendido = ref(false);

    const cargarConfiguracion = async () => {
      try {
        const response = await api.get('/config');
        const config = response.data.data;
        
        // Verificar modo del sistema
        modoSistema.value = config.modo_sistema || 1;
        sistemaSuspendido.value = modoSistema.value === 2;
        
        // Verificar si el aviso de mora está activo
        if (config.aviso_mora_activo === true && modoSistema.value === 1) {
          mostrarAvisoMora.value = true;
          mensajeMora.value = config.aviso_mora_mensaje || 'SISTEMA EN MORA - Contacte con el administrador';
        } else if (modoSistema.value === 2) {
          mostrarAvisoMora.value = true;
          mensajeMora.value = config.aviso_suspendido_mensaje || '🚫 SISTEMA SUSPENDIDO - Servicio no disponible';
        }
      } catch (error) {
        console.error('Error al cargar configuración:', error);
      }
    };

    const handleLogout = async () => {
      await authStore.logout();
      router.push('/login');
    };

    onMounted(() => {
      cargarConfiguracion();
      // Recargar configuración cada 5 minutos
      setInterval(cargarConfiguracion, 5 * 60 * 1000);
    });

    return {
      user,
      isAdmin,
      mostrarAvisoMora,
      mensajeMora,
      sistemaSuspendido,
      handleLogout
    };
  }
};
</script>

<style scoped>
.navbar-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.navbar-logo {
  height: 40px;
  width: auto;
}

.aviso-mora {
  background: linear-gradient(90deg, #ff3b30 0%, #ff453a 50%, #ff3b30 100%);
  background-size: 200% 100%;
  animation: gradient-shift 3s ease infinite;
  padding: 12px 20px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(255, 59, 48, 0.4);
}

.aviso-mora-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto;
}

.aviso-mora-icon {
  font-size: 24px;
  animation: pulse 1.5s ease infinite;
}

.aviso-mora-texto {
  color: white;
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

@keyframes gradient-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

.sistema-suspendido {
  background: linear-gradient(90deg, #1a1a1a 0%, #2d2d2d 50%, #1a1a1a 100%) !important;
}

.overlay-suspendido {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
}

.mensaje-suspendido {
  background: white;
  padding: 48px;
  border-radius: 16px;
  text-align: center;
  max-width: 500px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

.mensaje-suspendido h1 {
  font-size: 32px;
  margin-bottom: 16px;
  color: #1d1d1f;
}

.mensaje-suspendido p {
  font-size: 16px;
  color: #6e6e73;
  margin: 8px 0;
}
</style>